import { mapState, mapActions } from "vuex";

import { mdiMagnify,mdiWindowClose, mdiChevronRight,mdiChevronLeft,mdiClose,mdiClockTimeFiveOutline, mdiDownload, mdiEmailFastOutline, mdiCheckCircleOutline, mdiChevronDown, mdiArrowTopRightThinCircleOutline} from '@mdi/js'
export default {
  data() {
    return {
      icons:{
        mdiMagnify,
        mdiWindowClose,
        mdiChevronRight,
        mdiClose,
        mdiClockTimeFiveOutline,
        mdiDownload,
        mdiEmailFastOutline,
        mdiCheckCircleOutline,
        mdiChevronDown,
        mdiArrowTopRightThinCircleOutline,
        mdiChevronLeft
      },
    };
  },
  created() {

  },
  computed: {
    //导航功能
    ...mapState(["menuLists", "footerLists"]),
    autoBanner() {
      console.log(this.menuLists,'menuLists')
      let menuList = localStorage.getItem("menuLists")
        ? JSON.parse(localStorage.getItem("menuLists"))
        : [];
      let url = "";
      menuList.forEach((item) => {
        if (item.url == this.$route.fullPath) {
          url = item;
        } else {
          if (item.menu && item.menu.length) {
            item.menu.forEach((su) => {
              if (su.url == this.$route.fullPath) {
                url = su
              }
            });
          }
        }
      });

      return url
    },
  },
  methods: {
    ...mapActions(["app/setMenuLists", "app/setFooterLists"]),
    sendEmail(emails = null) {
      let systemInfo = JSON.parse(localStorage.getItem('systemObj'))
      let email = systemInfo.content; // 替换为你想发送的邮箱地址
      if(emails){
        email = emails
      }
      const subject = ''; // 替换为邮件的主题
      const body = ''; // 替换为邮件的正文
      const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
      console.log(mailtoLink,'mailtoLink')
      window.location.href = mailtoLink;
    },
    authPath(code, type,title) {
      let p = new Promise((resolve) => {
        let list = localStorage.getItem("menuLists")
          ? JSON.parse(localStorage.getItem("menuLists"))
          : [];
        let menu = [
          {
            text: this.$t('Home'),
            disabled: false,
            href: "/",
          },
        ];
        list.forEach((item) => {
          console.log(item,'item======')
          if (item.code == code) {
            menu.push({
              text: item.columnName,
              disabled: false,
              href: item.url,
            });
          } else {
            if (item.menu && item.menu.length) {
              item.menu.forEach((sitem) => {
                if (sitem.code == code) {
                  menu.push({
                    text: item.columnName,
                    disabled: false,
                    href: item.url,
                  });
                  menu.push({
                    text: sitem.columnName,
                    disabled: false,
                    href: sitem.url,
                  });
                }
              });
            }
          }
        });

        if (type == "detail") {
          menu.push({
            text: this.$t('Detail'),
            disabled: true,
            href: "",
          });
        } else if (type == "list") {
          menu[menu.length - 1].disabled = true;
        }else if(type == 'search'){
          menu.push({
            text:  this.$t('Search'),
            disabled: true,
            href: "",
          });
        }else if(type == 'title'){
          menu.push({
            text: title,
            disabled: true,
            href: "",
          });
        }
        resolve(menu)
      });
      return p
    },
    //处理标题
    async autoUrl(code) {
      let p = new Promise((resolve, reject) => {
        let menus = localStorage.getItem("footerLists")
          ? JSON.parse(localStorage.getItem("footerLists"))
          : "";
        if (!code) {
          return;
        }
        if (menus && menus.length) {
          menus.forEach((item) => {
            if (item.menu) {
              item.menu.forEach((sitem) => {
                if (sitem.code == code) {
                  console.log(sitem, "ss");
                  resolve(sitem.url);
                }
              });
            }
          });
        } else reject(null);
      });
      return p;
    },
    async getMenu() {
      const result = await this.Api.homeMenu();
      if (result.code == 200) {
        var list = [...result.data]
        this["app/setMenuLists"](list);
        this["app/setFooterLists"](list);
        setTimeout(() => {
          this.$Bus.$emit('updateMenuData')
          this.$Bus.$emit('updateFooterData')
        },10)
        setTimeout(() => {
          this.initTitle()
        },30)
        //

      }
    },
    initTitle() {
      let webTitle = ''
      let menuList = localStorage.getItem('menuLists') ? JSON.parse(localStorage.getItem('menuLists')) : []
      menuList.forEach((item) => {
        if (item.url == this.$route.fullPath) {
          webTitle = item.columnName
        } else {
          item.menu.forEach((sitem) => {
            if (sitem.url == this.$route.fullPath) {
              webTitle = sitem.columnName
            }
          })
        }
      })
      document.title = webTitle
    },
    getHomeIndex() {
      this.Api.homeDetails({ codes: "INDEX", isPage: 0 }).then((result) => {
        if (result.code == 200) {
          var source = result.data;
          Object.keys(source).forEach((item, index) => {
            if (index == 0) {
              let sourceData = source[item];
              if (sourceData.data) {
                let links = sourceData["data"]["link"]
                    ? sourceData["data"]["link"]
                    : {},
                  linksObj = {};
                let systemObj = sourceData["data"]["system"]
                  ? sourceData["data"]["system"]
                  : null;
                links.forEach((item) => {
                  linksObj[item.type] = {
                    label: item.typeName,
                    value: item.type,
                    list: [],
                  };
                });
                Object.keys(linksObj).forEach((item) => {
                  if(this.$i18n.locale == 'en'){
                    if(item == 0){
                      linksObj[item].label = this.$t('CentralNetworkGroup') 
                    }else if(item == 1){
                      linksObj[item].label = this.$t('Governmentwebsite')
                    }else if(item == 2){
                      linksObj[item].label = this.$t('IndustryBody')
                    }else if(item == 3){
                      linksObj[item].label = this.$t('EnterpriseCentralPartner')
                    }else if(item == 4){
                      linksObj[item].label = this.$t('CarPartner') 
                    }

                  }
                  linksObj[item].list = links.filter(
                    (sitem) => sitem.type == item
                  );
                });
                
                localStorage.setItem("linksObj", JSON.stringify(linksObj));
                setTimeout(() => {
                  this.$Bus.$emit('updateLinks')
                },10)
                if (systemObj) {
                  localStorage.setItem("systemObj", JSON.stringify(systemObj));
                }
                
              }
            }
          });
        }
      });
    },
    filterMenuCode(code) {
      var list = {};
      var menus = localStorage.getItem("footerLists")
        ? JSON.parse(localStorage.getItem("footerLists"))
        : [];
      menus.forEach((item) => {
        if (item.code == code) {
          if (item.menu && item.menu.length) {
            item.menu.forEach((sitem) => {
              list[sitem.columnName] = sitem.code;
            });
          }
        }
      });
      return list;
    },
    isMorePage(pageNum, pageSize, total, cb) {
      if (Math.ceil(total / pageSize) > pageNum) {
        cb(true);
      } else {
        cb(false);
      }
    },
  },
};
